module.exports = __webpack_public_path__ + "img/business-work-1.faa31ce1.jpg";